import { FC } from 'react';
import { Button, ButtonGroup } from '@chakra-ui/react';
import { UserType } from '../../graphql/generated';

export const userTypeLabels = {
  [UserType.EXTERNAL_USER]: 'External Users',
  [UserType.INTERNAL_USER]: 'Internal Users',
};

type UserTypeToggleType = {
  active: UserType | null | undefined;
  onClick: (userType: UserType) => void;
};

const Toggle: FC<UserTypeToggleType & { value: UserType }> = ({
  active,
  onClick,
  value,
}) => {
  const isActive = active === value;
  const label = userTypeLabels[value];

  return (
    <Button
      onClick={() => onClick(value)}
      data-testid={
        isActive ? 'user-type-toggle-active' : 'user-type-toggle-inactive'
      }
      color="gray.600"
      shadow="sm"
      isDisabled={isActive}
      // Active styles
      _disabled={{
        pointerEvents: 'none',
        color: 'gray.700',
        borderColor: 'gray.700',
        borderBottomWidth: '3px',
      }}
    >
      {label}
    </Button>
  );
};

export const UserTypeButtonsToggle: FC<UserTypeToggleType> = ({
  active,
  onClick,
}) => {
  return (
    <ButtonGroup isAttached variant="outline">
      <Toggle
        active={active}
        onClick={onClick}
        value={UserType.EXTERNAL_USER}
      />
      <Toggle
        active={active}
        onClick={onClick}
        value={UserType.INTERNAL_USER}
      />
    </ButtonGroup>
  );
};
